import { StringParam, useQueryParams } from 'use-query-params'

import { useQueryPage } from '@fourthwall/utils'

type FilterParams = {
  status: string | undefined
  salesChannel: string | undefined
  type: string | undefined
}

export const useFilterContributions = () => {
  const { setPage } = useQueryPage()
  const [queryParams, setQueryParams] = useQueryParams({
    status: StringParam,
    salesChannel: StringParam,
    type: StringParam,
  })

  const resetFiltersParams = () => {
    setPage(undefined)

    setQueryParams({
      status: undefined,
      salesChannel: undefined,
      type: undefined,
    })
  }

  const setFiltersParams = (params: FilterParams) => {
    setPage(undefined)
    setQueryParams(params)
  }

  const hasFilterParams = Object.values(queryParams).some((param) => param !== undefined)

  return {
    filtersParams: queryParams,
    setFiltersParams,
    resetFiltersParams,
    hasFilterParams,
  }
}
